import axios from "axios";
import { urlApi } from "../native/nativo";

/**
 * Shared HTTP Client for WasteMap App and Manager.
 * Configured with Axios to communicate with the unified WasteMap API (/api/v1).
 */
export const apiClient = axios.create({
  baseURL: urlApi("/api/v1"),
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Automatically inject Authorization token if available in storage
apiClient.interceptors.request.use(
  (config) => {
    // Check local storage for existing session token
    let token = localStorage.getItem("wastemap_auth_token");
    if (!token) {
      // Fallback: check Supabase auth tokens in localStorage
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("sb-") && key.endsWith("-auth-token")) {
          try {
            const raw = localStorage.getItem(key);
            if (raw) {
              const parsed = JSON.parse(raw);
              if (parsed?.access_token) {
                token = parsed.access_token;
                localStorage.setItem("wastemap_auth_token", token);
                break;
              }
            }
          } catch {}
        }
      }
    }
    if (token && config.headers) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Format errors and handle common status codes (e.g., 401 Unauthorized)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorResponse = error.response?.data;
    
    // Log normalized API errors for developer visibility
    if (errorResponse && errorResponse.success === false) {
      console.warn(
        `[API Error Response] Code: ${errorResponse.errorCode} - Message: ${errorResponse.message}`
      );
    } else {
      console.error("[Network/HTTP Error]:", error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
